<template>
    <form @submit.prevent="submitForm">
        <field-image required v-model="form.image_src"
                        :link="action+'/upload'"
                     placeholder=""/>
        <alert :success="success" :danger="danger"></alert>

        <button-delete title="حذف" class="float-left"
                       :link="action"
                       @deleted="itemDeleted"
                       v-show="edit" :id="edit"/>

        <button-submit title="ثبت"/>
    </form>
</template>

<script>
import ButtonSubmit from "../ButtonSubmit";
import Alert from "../Alert";
import FieldPassword from "../fields/FieldPassword";
import FieldMobile from "../fields/FieldMobile";
import FieldEmail from "../fields/FieldEmail";

import mixinForm from "../../mixins/mixinForm";
import FieldSelect from "../fields/FieldSelect";
import FieldText from "../fields/FieldText";
import FieldTextarea from "../fields/FieldTextarea";
import FieldSelectTree from "../fields/FieldSelectTree";
import FieldImage from "../fields/FieldImage";
import ButtonDelete from "../ButtonDelete";

export default {
  mixins: [mixinForm],
  components: {
    ButtonDelete,
    FieldImage,
    FieldSelectTree,
    FieldTextarea,
    FieldSelect,
    FieldText,
    FieldEmail,
    FieldMobile,
    FieldPassword,
    Alert,
    ButtonSubmit
  },
  name: "FormProduct",
  props: ["action"],
  methods: {
    itemDeleted() {
      this.$emit("deleted");
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/forms/FormProductImage.vue